export var ERROR_THIRD_PARTY_COOKIE = "The client specified not to prompt, but the user is not logged in";
export var REFRESH_TOKEN_INSPECTED_KEY = "okta-refresh-cookie-inspected";
